"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_1 = require("@pulse-web-ui/icons");
const i18n_1 = require("@pulse-web-platform-core/i18n");
const form_builder_style_1 = require("../form-builder.style");
const BackButton = ({ handleOnClickBack }) => {
    const { t } = (0, i18n_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(form_builder_style_1.BackButtonContainer, { children: (0, jsx_runtime_1.jsx)(form_builder_style_1.CustomButton, { variant: "text", icon: (0, jsx_runtime_1.jsx)(icons_1.Back, { color: "active", width: 24 }), onClick: handleOnClickBack, children: t('COMMON:labels.back') }) }));
};
exports.BackButton = BackButton;
